import { useEffect, useRef, useState } from "react";
import { ICota } from ".";
import { RelatorioControlo } from "../../../../../../types";
import axios from "axios";
import { buildEndpoint } from "../../../../../../services/api.service";
import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { IPecaParaEntrega } from "../../../../../Obras/newObra/IObra";




export function useRelatorioControloForm(relatorioControlo: RelatorioControlo, pecaEntrega: IPecaParaEntrega, relatorioContorloState: {hasChanges: boolean, setHasChanges: any}, closeForm: ()=> void) {

    const svgRef = useRef<any>(null);
    const [observacoes, setObservacoes] = useState(relatorioControlo.observacoes);
    const [conforme, setConforme] = useState(relatorioControlo.conforme)
    const [cotas, setCotas] = useState<ICota[]>([...relatorioControlo.cotas]);
    const [editMode, setEditMode] = useState(false);
    const [totalCotas, setTotalCotas] = useState(relatorioControlo.cotas.length);
    

    function doubleClickOnDesenho(event: any) {
        if (editMode) {
            setEditMode(false);
            return;
        }
        const svgElement = svgRef.current;
        if (!svgElement) return;
        const svgRect = svgElement.getBoundingClientRect();
        const x = event.clientX - svgRect.left;
        const y = event.clientY - svgRect.top;
        setTotalCotas((tc) => tc + 1);
        const newCota: ICota = {
            internalId: totalCotas,
            initialX: x,
            initialY: y,
            x,
            y,
            number: totalCotas,
            amostragens: [],
            valor: 0,
            intervaloDeTolerancia: {
                negativa: 0,
                positiva: 0
            },
            dispositivoMedicao: null
        }
        console.log("Quantidade de peças: ", pecaEntrega.quantidade);
        let numeroDeAmostras = pecaEntrega.quantidade;
        if (pecaEntrega.quantidade > 5 && pecaEntrega.quantidade <= 50) {
           numeroDeAmostras = Math.ceil(pecaEntrega.quantidade / 10);

        } else if (pecaEntrega.quantidade > 50 && pecaEntrega.quantidade <= 100) {
            numeroDeAmostras = Math.floor(2 * (pecaEntrega.quantidade / 20));
        } else if(pecaEntrega.quantidade > 100) {
            numeroDeAmostras = 2 * Math.floor((pecaEntrega.quantidade / 100));
        }
        console.log("====> Número de peças: ", numeroDeAmostras);
        newCota.amostragens = Array(numeroDeAmostras).fill({ valor: 0 }).map((a, idx) => ({valor: a.valor, numero: idx}));
        // setCotas([...cotas, newCota]);
        createCotaMutation.mutate({ cota: newCota });
    }

    const createCota = async (cota: ICota): Promise<any> => {
        const response = await axios.post(buildEndpoint(`/relatorios-controlo/${relatorioControlo?.id}/cotas`), cota);
        return response.data;
    }

    const updateRelatorio = async (relatorio: Partial<RelatorioControlo>) : Promise<RelatorioControlo> => {
        const response = await axios.put(buildEndpoint(`/relatorios-controlo/${pecaEntrega?.id}`), {
            conforme: relatorio.conforme,
            observacoes: relatorio.observacoes
        });
        return response.data;
    }

    const updateCotaOnServer = async (cota: ICota): Promise<any> => {
        const response = await axios.put(buildEndpoint(`/relatorios-controlo/${relatorioControlo?.id}/cotas/${cota.internalId}`), cota);
        return response.data;
    }

    const deleteCotaFromServer = async (relatorioControloId: number | null, cotaId: number | null): Promise<any> => {
        const response = await axios.delete(buildEndpoint(`/relatorios-controlo/${relatorioControloId}/cotas/${cotaId}`));
        return response.data;
    }

    const createCotaMutation = useMutation(({ cota }: { cota: ICota }) => createCota(cota), {
        onSuccess: (cota: ICota) => {
            toast.success("Cota criada com sucesso");
            setCotas([...cotas, cota]);
        }, onError: () => {
            toast.error("Erro ao criar cota");
        }
    });

    const updateRelatorioMutation = useMutation(({relatorio} : {relatorio: Partial<RelatorioControlo>}) => updateRelatorio(relatorio), {
        onSuccess: () => {
            toast.success("Relatorio atualizado com sucesso");
            bulkSaveCotas();
            
        }, onError: () => {
            toast.error("Erro ao atualizar relatório");
        }
    })

    const updateCotaMutation = useMutation(({ cota }: { cota: ICota }) => updateCotaOnServer(cota), {
        onSuccess: () => {
            toast.success("Cota atualizada com sucesso");

        }, onError: () => {
            toast.error("Erro ao criar cota");
        }
    });

    const deleteMutation = useMutation(({ relatorioControloId, cotaId }: { relatorioControloId: number | null, cotaId: number | null }) => deleteCotaFromServer(relatorioControloId, cotaId), {
        onSuccess: () => {
            toast.success("Cota eleiminada com sucesso")
        }, onError: () => {
            toast.error("Erro ao eliminar cota");
        }
    });


    const updateCota = (n: number, value: Partial<ICota>) => {
        const index = cotas.findIndex((c) => c.internalId === n);
        cotas[index] = { ...cotas[index], ...value };
        setCotas([...cotas]);
    }

    const addAmostragem = (n: number) => {
        const index = cotas.findIndex((c) => c.internalId === n);
        cotas[index].amostragens.push({numero: cotas[index].amostragens.length , valor: 0});
        setCotas([...cotas]);
        relatorioContorloState.setHasChanges(true);
    }

    const updateAmostragens = (n: number, idx: number, value: number) => {
        const index = cotas.findIndex((c) => c.internalId === n);
        cotas[index].amostragens[idx] = {...cotas[index].amostragens[idx], valor: value};
        setCotas([...cotas]);
        relatorioContorloState.setHasChanges(true);

    }

    const deleteCota = (n: number) => {
        const cotaToDelete = cotas.filter((c) => c.internalId === n)[0];
        deleteMutation.mutate({ relatorioControloId: relatorioControlo?.id, cotaId: cotaToDelete.internalId })
        setCotas([...cotas.filter((c) => c.internalId !== n)]);
    }


    

    const bulkSaveCotas = async () => {
        await Promise.all(cotas.map(async (c: ICota) => updateCotaMutation.mutate({cota: c})));
        relatorioContorloState.setHasChanges(false);
        closeForm();
    }

    return {
        svgRef,
        observacoes,
        setObservacoes,
        conforme,
        setConforme,
        cotas,
        updateCota,
        updateCotaMutation,
        updateRelatorioMutation,
        createCota,
        deleteCota,
        doubleClickOnDesenho,
        updateAmostragens,
        addAmostragem,
    }


} 